import React from 'react';
import { useSessions } from '~/hooks/vendors/useSessions';
import { useLineUserAccounts } from '~/hooks/vendors/useLineUserAccounts';
import { LineUserAccountList } from '~/components/common/line_user_accounts/LineUserAccountList';
import { LineUserAccountModal } from '~/components/common/line_user_accounts/LineUserAccountModal';
import type { NskResponse } from '~/models/Api';
import type { LineUserAccountEdit } from '~/models/LineUserAccount';
import { create, update, destroy } from '~/utils/api/vendors/LineUserAccounts';

type Props = {
  onClose: () => void;
  isOpen: boolean;
};

export const LineUserAccounts: React.FC<Props> = ({ onClose, isOpen }) => {
  const { data: session } = useSessions().index();
  const { data: lineUserAccounts, mutate: mutateLineUserAccounts } =
    useLineUserAccounts().index();
  const handleCreate = React.useCallback(
    async (lineUserAccountEdit: LineUserAccountEdit): Promise<NskResponse> =>
      create(lineUserAccountEdit),
    []
  );
  const handleUpdate = React.useCallback(
    async (
      lineUserAccountEdit: LineUserAccountEdit,
      lineUserAccountId: number
    ): Promise<NskResponse> => update(lineUserAccountEdit, lineUserAccountId),
    []
  );
  const handleDestroy = React.useCallback(
    async (lineUserAccountId: number): Promise<NskResponse> =>
      destroy(lineUserAccountId),
    []
  );
  const handleMutate = React.useCallback(async () => {
    await mutateLineUserAccounts?.();
  }, [mutateLineUserAccounts]);
  if (session === null || lineUserAccounts === null) {
    return null;
  }
  return (
    <>
      <LineUserAccountList
        handleDestroy={handleDestroy}
        handleMutate={handleMutate}
        handleUpdate={handleUpdate}
        lineUserAccounts={lineUserAccounts.lineUserAccounts}
      />
      <LineUserAccountModal
        handleClose={onClose}
        handleCreate={handleCreate}
        handleMutate={handleMutate}
        isOpen={isOpen}
      />
    </>
  );
};
